import React, {Component} from "react";
import NavbarComponent from "../components/NavbarComponent";
import OverviewTable from "../components/tables/OverviewTable";

class OverviewPage extends Component{

    render() {
        return (
            <div>
                <NavbarComponent initValue={"/overview"}/>
                <OverviewTable/>
            </div>
        );
    }
}

export default OverviewPage;